import * as React from 'react';
import { Grid, Row, Col } from 'react-flexbox-grid';
import { get } from 'lodash';
import Divider from 'material-ui/Divider';

import { Input, InputField, RemoteAutoCompleteField, RemoteAutoComplete, UploadField, Upload } from '@components/form';
import { reportProvidersEnum } from '@modules/reports/_reportsEnums';

const valueFn = parent => get(parent, 'id');

const View: React.SFC<any> = _props => (
  <div>
    <Grid fluid={true}>
      <Row>
        <Col md={6} className="with-right-divider">
          <Row>
            <Col md={12}>
              <h4>Soubor</h4>
            </Col>
            <Col md={12}>
              <InputField component={Input} id={'name'} name={'name'} label={'Jméno'} />
            </Col>
            <Col md={12}>
              <InputField component={Input} multiLine={true} id={'label'} name={'label'} label={'Popis'} />
            </Col>
            <Col md={12}>
              <Row>
                <Col md={6}>
                  <InputField component={Input} id={'fileName'} name={'fileName'} label={'Název souboru'} />
                </Col>
                <Col md={6}>
                  <UploadField
                    component={Upload}
                    name="template"
                    style={{
                      justifyContent: 'flex-end',
                      height: '62px',
                      margin: '5px'
                    }}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
        <Col md={6} className="with-right-divider">
          <Row>
            <Col md={12}>
              <h4>Ostatní</h4>
            </Col>
            <Col md={12}>
              <RemoteAutoCompleteField
                component={RemoteAutoComplete}
                label="Třída poskytovatele"
                name="provider"
                id="provider"
                url="/metropolis/api/reports/providers"
                fullWidth={true}
                labelFunction={o =>
                  get(
                    reportProvidersEnum.find(p => get(p, 'id') === get(o, 'id')),
                    'label',
                    get(o, 'name')
                  )
                }
                valueFunction={valueFn}
              />
            </Col>
            <Col md={12}>
              <RemoteAutoCompleteField
                component={RemoteAutoComplete}
                label="Lokace"
                name="location"
                id="location"
                url="/metropolis/api/reports/locations"
                fullWidth={true}
                labelFunction={o => get(o, 'name')}
                valueFunction={valueFn}
              />
            </Col>
            <Col md={12}>
              <InputField component={Input} id={'params'} name={'params'} label={'Parametre'} />
            </Col>
          </Row>
        </Col>
      </Row>
    </Grid>
    <Divider />
  </div>
);
export const ReportsFormBasic = View;



// WEBPACK FOOTER //
// ./src/modules/reports/ReportsFormBasic.tsx